import React, { useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { ResponseType } from "./ResponseType";
import { getMessage } from "../util";

const NotFound = (props: ResponseType) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <Row className={"justify-content-center"}>
            <Col
                xs={12}
                sm={11}
                md={9}
                lg={7}
                className={"consulta-text px-4 px-sm-2"}
            >
                <p className="lead mb-1">Resultado de su consulta:</p>
                <p className="lead fw-bold mb-4">
                    No te encuentras habilitad@ para votar por este medio
                </p>
                <p>
                    Según información aportada en tu inscripción a la Mesa en&nbsp;
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://inscripcionmnscm.cancilleria.gov.co"
                    >
                        https://inscripcionmnscm.cancilleria.gov.co
                    </a>
                    , el número de documento que ingresaste no se encuentra en el registro a la Mesa, por favor vuelve a intentarlo.
                </p>
                <p  className={"fw-bold"}>Información:</p>
                <ul>
                    <li>Vuelve a intentar haciendo clic en el botón “Volver a Consultar”.</li>
                    <li>Recuerda que SOLO estarás habilitado si te inscribiste en la Mesa antes del 19 de noviembre del 2024</li>
                    <li>Si tienes alguna duda o consulta podrá diligenciar el&nbsp;
                        <a className="text-nowrap" rel="noreferrer" target="_blank" href="https://evoting.typeform.com/to/VKwDaENo">formulario de asistencia</a>.
                    </li>
                </ul>

                <Row className={"justify-content-center"}>
                    <Col xs={12} sm={11} md={9} lg={7} className={"text-center my-1"}>
                        <Button
                            className="EvColorGrisLight m-1 w-75 border-dark"
                            onClick={props.volver}
                            style={{ minWidth: "250px" }}
                            variant="light"
                        >
                            {getMessage("ask_again", props.messages)}
                        </Button>
                    </Col>
                    <Col xs={12} sm={11} md={9} lg={7} className={"text-center my-1"}>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://evoting.typeform.com/to/VKwDaENo"
                            className="EvColorGrisLight m-1 w-75 btn-light btn text-nowrap border-dark"
                            style={{ minWidth: "250px" }}
                        >
                            {getMessage("asistencia", props.messages)}
                        </a>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default NotFound;
